

export const columns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
    printWidth: 0.4
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    width: 180,
    printWidth: 1.5
  },
  {
    field: "LicNm",
    headerName: "ทะเบียนรถ",
    width: 100,
    printWidth: 0.8
  },
]